import { createSelector } from 'reselect'
import { getCheckoutBenefitsView } from 'luxPlus/selectors/checkout/benefits'
import { isLuxPlusStandaloneStepAvailable } from './navigationSelectors'

/**
 * Funnel/membership eligibility plus actual upsell content.
 *
 * Kept out of `navigationSelectors` to avoid a cycle:
 * benefits → tourV2Selectors → navigationSelectors.
 *
 * While benefits are still loading (`hasRequiredData` is false) we stay optimistic
 * so checkout can land on the LuxPlus page; once resolved with no eligible
 * benefits the step is removed and routing skips it.
 */
export const isLuxPlusStandaloneStepAvailableWithContent = createSelector(
  (state: App.State) => isLuxPlusStandaloneStepAvailable(state),
  (state: App.State) => getCheckoutBenefitsView(state),
  (
    isLuxPlusStepAvailable,
    checkoutBenefitsView,
  ): boolean => {
    if (!isLuxPlusStepAvailable) return false
    return !checkoutBenefitsView.hasRequiredData || !!checkoutBenefitsView.data
  },
)
